module.exports = __webpack_public_path__ + "img/service_hover.625229a4.svg";